import "../auth/auth.css";
import { Link } from "react-router-dom";
import close_btn from "../../assets/images/close-btn.svg";

const VerificationSuccess = () => {
  return (
    <div>
      <div className="overlay">
        <div className="pop-contain">
          <div className="popup-content">
            <div className="verif">
              <h4>Verification Successful</h4>
              <img src={close_btn} alt="" height="32px" />
            </div>
            <p>
              Your email has successfully been verified, click to visit your
              dashboard to start using Shelf21 fully.
            </p>
            <Link to="/dashboard">
              <button className="auth-create-button white bg-app-primary">
                Go to Dashboard
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationSuccess;
